exports.a = 2
exports.b = 'ciao'
